import { memo } from 'react';
import IntroPromoLabel from '../../IntroPromoLabel/IntroPromoLabel';
import { Box, Button } from '@bonanza-social/moonlight';
import { StackNavigationProp, useNavigation } from '@bonanza-social/navigation';
import { AuthNavigatorParamsList } from '../../../navigators/AuthNavigator/AuthNavigator.types';

function IntroMainContentDefault() {
  const navigation =
    useNavigation<StackNavigationProp<AuthNavigatorParamsList>>();
  return (
    <Box gap="space-400" paddingBottom="space-400">
      <IntroPromoLabel />
      <Box gap="space-300">
        <Button
          locKey="login"
          locNS="auth"
          size="large"
          onPress={() => navigation.navigate('LoginScreen')}
        />
        <Button
          locKey="join"
          locNS="auth"
          variant="secondary"
          size="large"
          onPress={() => navigation.navigate('RegistrationScreen')}
        />
      </Box>
    </Box>
  );
}
export default memo(IntroMainContentDefault);
